export const headingSmall = {
    size: 16,
    lineHeight: 24,
    weight: 700
};
export const headingMedium = {
    size: 24,
    lineHeight: 34.8,
    weight: 700
};
export const theme = {
    text: {
        xxSmall: '10px',
        xSmall: '12px',
        small: '14px',
        medium: '16px',
        large: '18px',
        xLarge: '20px',
        xxLarge: '24px',
        xxxLarge: '28px',
        xxxxLarge: '38px'
    }
};
//# sourceMappingURL=index.js.map